enum WarehouseStatus {
    Existing= 1,
    WaitForDelivery = 2,
    WaitReturnDelivery = 3,
    WaitChange = 4
}

export default WarehouseStatus